import axios from "axios";
import { API_URL } from "./client-config";
export default axios.create({
  baseURL: API_URL
});
